'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var NoStyleButton_web = require('../../atoms/NoStyleButton/NoStyleButton.web.cjs');
var Pill_web = require('../../atoms/Pill/Pill.web.cjs');
var Popover_web = require('../../atoms/Popover/Popover.web.cjs');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var PillGroup_web_styles = require('./PillGroup.web.styles.cjs');

/**
 * @scope Web
 *
 * A group of pills to label, categorize, or organize items
 */ const PillGroup = ({ pills, size, truncateAfter, customCss, ...rest })=>{
    const renderPills = pills?.map((pill, index)=>{
        if (truncateAfter === 0 || truncateAfter && index >= truncateAfter) {
            return null;
        }
        return /*#__PURE__*/ jsxRuntime.jsx(Pill_web.Pill, {
            size: size,
            intention: pill.intention ?? "neutral",
            tooltipContent: pill.tooltipContent,
            children: pill.pillContent
        }, index);
    });
    const renderTruncation = ()=>{
        if (truncateAfter === undefined || truncateAfter >= pills.length || truncateAfter < 0) return null;
        const tooltip = pills.slice(truncateAfter).map((pill)=>/*#__PURE__*/ jsxRuntime.jsxs(Typography_web.Typography, {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("strong", {
                        children: pill.pillContent
                    }),
                    pill.tooltipContent && `: ${pill.tooltipContent}`,
                    /*#__PURE__*/ jsxRuntime.jsx("br", {})
                ]
            }, pill.pillContent));
        return /*#__PURE__*/ jsxRuntime.jsxs(Popover_web.Popover, {
            children: [
                /*#__PURE__*/ jsxRuntime.jsx(Popover_web.Popover.Trigger, {
                    children: /*#__PURE__*/ jsxRuntime.jsx(NoStyleButton_web.NoStyleButton, {
                        children: /*#__PURE__*/ jsxRuntime.jsx(Pill_web.Pill, {
                            size: size,
                            intention: "neutral",
                            children: `${(pills.length - truncateAfter).toString()}+`
                        })
                    })
                }),
                /*#__PURE__*/ jsxRuntime.jsx(Popover_web.Popover.Content, {
                    children: tooltip
                })
            ]
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: [
            PillGroup_web_styles.pillGroup,
            customCss
        ],
        ...rest,
        children: [
            renderPills,
            renderTruncation()
        ]
    });
};

exports.PillGroup = PillGroup;
//# sourceMappingURL=PillGroup.web.cjs.map
